/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Column, Bleed } from '../../../../../styles/Grid';
import Picture from '../../../../ui/Picture';
import { Breakpoints } from '../../../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../../../utils/constants';
import {
  containerCss,
  imageLeftContainer,
  imageLeftCss,
  imageRightNextContainer,
  imageRightTopCss,
  imageRightBottomCss,
  imageRightContainer,
  bleedImageRightDimentionCss,
} from './index.styles';
import { pictureStyles, imageStyles } from '../../index.styles';

const imageLeftSizes = {
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '13:10',
    gravity: 'auto:subject',
    width: 843,
    height: 647,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '13:10',
    gravity: 'auto:subject',
    width: 843,
    height: 647,
  },
  [Breakpoints.md]: {
    hidden: true,
  },
  [Breakpoints.sm]: {
    hidden: true,
  },
};

const imageRightTopSizes = {
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '74:49',
    gravity: 'auto:subject',
    width: 367,
    height: 244,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '74:49',
    gravity: 'auto:subject',
    width: 367,
    height: 244,
  },
  [Breakpoints.md]: {
    hidden: true,
  },
  [Breakpoints.sm]: {
    hidden: true,
  },
};

const imageRightBottomSizes = {
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '23:16',
    gravity: 'auto:subject',
    width: 414,
    height: 288,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '23:16',
    gravity: 'auto:subject',
    width: 414,
    height: 288,
  },
  [Breakpoints.md]: {
    hidden: true,
  },
  [Breakpoints.sm]: {
    hidden: true,
  },
};

const FirstLgTabImage = (imageRight, imageLeft, imageRightNextComponent) => {
  return (
    <div css={containerCss} key="first-lg-regus-tab">
      <Column cols={{ lg: 1 }}>
        <Bleed left>
          <div css={imageLeftContainer}>
            <Picture
              image={imageLeft}
              imageSizes={imageLeftSizes}
              pictureCss={pictureStyles}
              imageCss={[imageStyles, imageLeftCss]}
            />
          </div>
        </Bleed>
      </Column>
      <Column cols={{ lg: 1 }} offsets={{ lg: 11 }}>
        <Bleed css={bleedImageRightDimentionCss} right>
          <div css={imageRightNextContainer}>
            <Picture
              image={imageRightNextComponent}
              imageSizes={imageRightTopSizes}
              pictureCss={pictureStyles}
              imageCss={[imageStyles, imageRightTopCss]}
            />
          </div>
        </Bleed>
      </Column>
      <Column cols={{ lg: 3 }} offsets={{ lg: 9 }}>
        <Bleed right>
          <div css={imageRightContainer}>
            <Picture
              image={imageRight}
              imageSizes={imageRightBottomSizes}
              pictureCss={pictureStyles}
              imageCss={[imageStyles, imageRightBottomCss]}
            />
          </div>
        </Bleed>
      </Column>
    </div>
  );
};

export default FirstLgTabImage;
